export const speechQuotes = [
  `“그건 좀 더 알아보고 말씀드릴게요.”\n
이런 식으로 신중하게 말하는 사람이라면 태음인일 가능성이 높습니다.
태음인은 속이 깊고 조심성이 많아 쉽게 결정을 내리기보다는 모든 가능성을 검토하고 나서 입을 엽니다.
이들의 말은 조용하지만 무게가 있고, 때로는 지나치게 생각이 많아 행동이 느려질 수 있습니다.
이런 사람과 대화할 땐 빠른 답변을 재촉하기보다 충분한 시간과 여유를 주는 것이 신뢰를 쌓는 길입니다.`,

  `“괜찮아요. 그냥 천천히 해요.”\n
이런 말을 자주 하는 사람은 소음인일 수 있습니다.
소음인은 내향적이고 안정 지향적이며, 타인의 감정을 세심하게 살피는 특징이 있습니다.
말을 할 때도 직설적이기보다는 조심스럽고 부드럽게 표현하며, 변화보다는 익숙한 것을 선호합니다.
소음인과 소통할 때는 무리하게 감정을 끌어내기보다 일관된 태도로 안정감을 주는 것이 좋습니다.`,

  `“이거 해보면 재밌지 않을까요?”\n
이렇게 활기차게 나서는 사람은 소양인일 가능성이 높습니다.
소양인은 낙천적이고 활동적이며, 새로운 것을 시도하는 데 거침이 없습니다.
말투에도 생동감과 속도감이 있으며, 분위기를 주도하려는 경향이 강하죠.
이들과 대화할 때는 호응과 리액션이 중요하며, 급하게 확장되려는 에너지를 부드럽게 조율해주는 균형감도 필요합니다.`,

  `“제가 정리해둘게요. 나중에 필요하실 거예요.”\n
이런 말버릇은 태음인에게서 자주 들을 수 있습니다.
한 번 나서면 체계적으로 정리하고 끝까지 책임지려는 기질이 강하죠.
실제 상황에서 눈에 띄는 표현은 많지 않지만, 뒤에서 조용히 판을 짜는 경우가 많습니다.
이들과의 대화에서는 단순한 칭찬보다 신뢰와 역할의 명확함이 큰 동력이 됩니다.`,

  `“그건 아닌 것 같은데요.”\n
이 짧은 말 속에는 소양인의 직관적 판단과 자존감이 드러납니다.
소양인은 머릿속에서 재빠르게 시뮬레이션을 돌리고, 상황이 아니다 싶으면 바로 브레이크를 걸죠.
하지만 단호함 속에도 ‘나를 믿어줘’라는 메시지가 숨어 있습니다.
이들과의 대화에서는 설득보다 공감, 반론보다 리액션이 잘 통합니다.`,

  `“이건 왜 이런 거예요?”\n
질문으로 시작하는 이 말버릇은 태양인의 관찰력과 문제의식이 반영된 표현입니다.
태양인은 세상을 바꾸고 싶어 하고, 구조적인 시야를 가지고 있어 종종 질문으로 문제를 드러냅니다.
이 말은 단순한 호기심이 아니라 ‘이 구조가 옳은가?’를 묻는 신호일 수 있습니다.
이들에게는 형식보다 진심, 권위보다 논리가 먹힙니다.`,

  `“혹시 불편하신 건 없으세요?”\n
이런 다정하고 배려심 깊은 말은 소음인의 대표적 화법입니다.
소음인은 자신의 감정을 억누르고도 타인을 먼저 챙기려는 경향이 있습니다.
이들의 말은 조용하지만 마음이 담겨 있고, 갈등을 피하려는 조심스러움이 깃들어 있습니다.
너무 직선적인 피드백은 오히려 위축을 줄 수 있으므로, 천천히 따뜻하게 표현하는 것이 좋습니다.`,

  `“그냥 제가 할게요.”\n
이 말은 태음인의 책임감과 내면의 소명의식에서 비롯됩니다.
한 번 마음을 정하면 묵묵히 모든 것을 감당하려는 태도가 강하죠.
때로는 말없이 감정을 삭이며 타인의 몫까지 끌어안기도 합니다.
이들에게는 ‘수고했다’는 한 마디보다 실제 부담을 덜어주는 행동이 더 깊이 닿습니다.`,

  `“딱 지금이 기회인 것 같아요.”\n
이렇게 직감적으로 상황을 읽고 기회를 포착하는 말은 소양인의 상징 같은 표현입니다.
늘 앞을 보고 있으며, 미래를 상상하고 움직이려는 열정이 담겨 있습니다.
이들의 언어는 때로 무모하게 들릴 수 있지만, 거기엔 시작의 힘이 있습니다.
이들에게는 기회를 말리는 대신, 방향을 함께 설계해주는 조언이 도움이 됩니다.`,

  `“큰 틀은 이런 식으로 잡아야죠.”\n
이 말은 태양인의 시야와 야망을 그대로 보여주는 표현입니다.
세부보다 방향, 디테일보다는 판 전체를 읽으려는 성향이 강합니다.
말에는 추진력과 권위가 깃들어 있으며, 듣는 사람을 압도하기도 하죠.
하지만 이들과 협업하려면 작은 논쟁보다는 전체 맥락에 대한 질문이 더 효과적입니다.`,

  `“제가 정리해둘게요. 나중에 필요하실 거예요.”\n
이런 말버릇은 태음인에게서 자주 들을 수 있습니다.
한 번 나서면 체계적으로 정리하고 끝까지 책임지려는 기질이 강하죠.
이들과의 대화에서는 단순한 칭찬보다 신뢰와 역할의 명확함이 큰 동력이 됩니다.`,

  `“그건 아닌 것 같은데요.”\n
이 짧은 말 속에는 소양인의 직관적 판단과 자존감이 드러납니다.
소양인은 머릿속에서 재빠르게 시뮬레이션을 돌리고, 상황이 아니다 싶으면 바로 브레이크를 겁니다.
이들과의 대화에서는 설득보다 공감, 반론보다 리액션이 잘 통합니다.`,

  `“저는 일단 듣고 정리하는 편이에요.”\n
이 말은 소음인의 신중한 스타일을 보여줍니다.
즉각 반응하기보다 전반적인 흐름을 이해한 후 자신의 관점을 드러내죠.
이들에게는 무리하게 말을 끌어내기보다, 기다려주는 태도가 신뢰를 쌓는 데 중요합니다.`,

  `“왜 그렇게 안 하셨어요?”\n
이런 말은 태음인의 원칙 중시 성향에서 비롯됩니다.
정해진 규칙이나 기준에서 벗어나는 상황에 민감하게 반응하며, 일의 체계를 중시하죠.
이들과의 갈등을 피하려면 사전 공유와 절차 존중이 필수입니다.`,

  `“이거, 지금 바로 해보면 감이 올 것 같은데요?”\n
이런 식의 말은 소양인에게서 자주 들을 수 있습니다.
이들은 직감적으로 판단하고 빠르게 반응하는 스타일로,
머릿속에서 복잡한 시뮬레이션을 돌리기보다는 몸으로 먼저 부딪히며 방향을 잡으려는 성향을 보입니다.
상황을 오래 고민하기보다 해봐야 감이 잡힌다는 태도로 움직이며,
일단 시작해놓고 세부를 조정하는 방식을 선호하죠.
그래서 말투엔 에너지와 자신감이 넘치지만, 그 속엔 ‘지금 아니면 기회를 놓칠 수도 있다’는 불안한 긴박감도 함께 있습니다.
소양인의 말은 명확하고 단도직입적이며, 대화를 주도하려는 경향이 있지만,
자세히 들어보면 결과보다 흐름과 반응에 더 민감한 스타일임을 알 수 있습니다.
이런 사람과 함께할 때는, 생각을 가로막기보다 “좋아요, 해보고 조정해보죠”처럼
즉흥성과 실행력을 인정해주는 리액션이 잘 통합니다.
그들의 빠름은 가볍기 때문이 아니라, 기회를 향한 예민한 촉의 반영일 수 있습니다.
속도 안에 있는 열정을 이해하면, 소양인은 가장 강력한 추진력의 파트너가 될 수 있습니다.`,

  `“그건 좀 복잡한 얘기라 지금 말하긴 애매하네요.”\n
이런 식의 애매모호한 회피성 표현은 소음인에게서 자주 나타납니다.
소음인은 감정이 상하거나 갈등이 일어나는 상황을 부담스러워하며, 자기 입장을 드러내는 데 조심스럽습니다.
이들은 불편함을 직접 말하지 않고, 완곡하게 넘어가려 하죠.
이럴 땐 깊이 캐묻기보다, ‘나중에 편할 때 얘기해줘’ 같은 여유 있는 반응이 효과적입니다.`,

  `“일단 가만히 좀 보고 있어도 될까요?”\n
이 말은 태음인 특유의 내면 관찰적 태도를 잘 보여줍니다.
태음인은 섣불리 판단하지 않고 상황을 오래 지켜본 뒤에 신중하게 반응하는 경향이 있습니다.
말수는 적지만 마음속 계산은 빠르고 깊으며, 타인을 평가하기보다는 스스로 확신이 설 때 움직입니다.
이들에게는 조급함을 유발하기보다 기다려주는 것이 신뢰로 이어집니다.`,

  `“그거 제가 한 번 정리해서 다시 제안해볼게요.”\n
이런 말에는 소양인의 추진력과 논리 정리 능력이 담겨 있습니다.
소양인은 감각적으로 판단하고 에너지가 넘치지만, 동시에 실용적인 전략 감각도 가지고 있죠.
자신의 생각을 정리해서 보여주려는 태도는 그만큼 주도권을 쥐고 싶어 하는 욕구의 표현일 수 있습니다.
이들과 협업할 때는 방해하지 말고, 아이디어를 현실화할 수 있게 잘 리딩해주는 게 중요합니다.`,

  `“이 문제는 시스템 차원에서 다시 봐야 하지 않을까요?”\n
이런 말을 자주 하는 사람은 태양인일 가능성이 높습니다.
태양인은 문제를 부분적으로 고치기보다는 전체 구조나 시스템을 재설계하려는 사고방식을 가집니다.
자신이 어떤 흐름 속에 놓여 있는지를 늘 의식하며, 개인보다 조직, 감정보다 설계, 현상보다 원인을 먼저 봅니다.
이들은 주로 높은 시야에서 '지금 이 판이 어떻게 짜여 있는가'를 살펴보며, 현실의 혼란을 ‘프레임 오류’로 해석하려는 경향이 있습니다.
말의 어투에는 분석력과 통제력, 그리고 때로는 상대를 압도하는 권위가 담겨 있기도 하죠.
그렇기에 이런 사람과 대화할 땐, 감정에 호소하기보다는 “그럼 어떤 구조가 더 적절할까요?”처럼 구조적 판단을 자극하는 질문이 훨씬 효과적입니다.
'시스템 차원'이라는 말 속에는 단순한 회피가 아니라, 한 걸음 위에서 본질을 꿰뚫고자 하는 태양인의 사고방식이 담겨 있는 것입니다.`,

  `“일단 상황부터 좀 더 파악해보고 말씀드릴게요.”\n
이런 식의 말은 태음인에게서 자주 들을 수 있습니다.
태음인은 섣불리 단정하지 않고, 충분히 관찰한 뒤 신중하게 의견을 내는 성향을 가집니다.
마음속으로는 이미 방향을 정해두었더라도, 겉으로는 신중한 판단자처럼 행동하려는 경향이 강하죠.
이들은 내면이 깊고, 한 번 결정하면 쉽게 바꾸지 않지만, 그 결정을 밖으로 드러내는 데엔 시간을 들입니다.
그래서 태음인의 말은 언제나 조금 느리고 조심스러우며, 정리되지 않은 상황에서는 말 자체를 아끼는 경향도 있습니다.
말투만 보면 무관심처럼 느껴질 수 있지만, 실제로는 모든 것을 머릿속에서 구조화하고 정리하고 있는 중입니다.
이런 사람에게는 재촉보다는 여지를 주는 것이 좋습니다.
“언제까지 정리해볼 수 있을까요?”처럼 기한은 제시하되 판단은 위임하는 질문이 훨씬 잘 통합니다.
신중함은 그들의 속도이며, 그 느림 안에는 책임감과 진중함이 함께 담겨 있습니다.`,

  `“괜찮아요, 저는 그냥 조용히 있는 게 편해요.”\n
소음인은 감정 표현이 적고, 조용한 환경에서 마음의 안정을 찾는 체질입니다.
겉으론 차분하지만 주변 상황을 민감하게 살피며, 낯선 관계엔 쉽게 마음을 열지 않습니다.
억지로 말을 시키거나 주목을 끌면 오히려 위축될 수 있어, 부담 없는 배려와 기다림이 좋은 관계로 이어집니다.`,

  `“결국은 내 방식이 맞더라니까.”\n
이 말은 강한 추진력과 독립성을 지닌 태양인의 전형적인 말버릇입니다.
태양인은 자신의 방식에 대한 확신이 강하며, 경험을 통해 증명되었음을 강조하고 싶어 하죠. 
논리적 근거보다는 ‘결과 중심’의 시각에서 세상을 보고, 남의 조언도 끝내는 자기 틀 안에서 재해석하려는 경향이 있습니다.
정면 반박보다는 “맞아요, 결국 그렇게 돼서 놀랐어요”처럼 일단 긍정해주면서, 조금씩 다른 관점을 제시해보는 방식이 효과적입니다. 
전체 그림을 중시하는 이들에게는 작은 디테일보다는 방향성과 의미를 중심으로 대화하는 것이 좋습니다.`,

  `“그건 좀 아닌 것 같은데요… 음…”\n
이 말은 직접적으로 반대 의견을 표현하기보다는, 완곡하게 선을 긋고 싶은 소음인의 말버릇입니다.
소음인은 신중하고 조심스러운 성향 때문에, 감정의 파장을 최소화하려고 노력합니다. 
부정적인 말을 꺼낼 때는 늘 여지를 남기고, 상대가 스스로 물러날 수 있도록 암시하죠.
이들의 말을 무시하거나 강하게 몰아세우면 속으로 더 움츠러들 수 있어요. 
“어떤 부분이 좀 그랬을까요?”처럼 조심스레 물어보며, 말 뒤에 숨은 진짜 의중을 끌어내는 게 중요합니다. 
부드러운 소통을 통해 신뢰를 쌓으면 진심을 들을 수 있어요.`,

  `“지금 그 얘길 꼭 해야 돼요?”\n
소양인은 활달하고 명랑한 성격을 가졌지만, 부정적인 분위기나 감정의 골이 깊어지는 상황을 꺼려합니다.
갈등이 생길 조짐이 보이거나, 자신이 감정을 다루기 불편한 주제가 등장하면 대화를 유머로 돌리거나 피하려고 하죠. 
그래서 이 말은 ‘지금은 기분 좋게 가고 싶으니 복잡한 얘기는 나중에 하자’는 뜻이기도 합니다.
정색하고 밀어붙이기보다는, 분위기를 누그러뜨린 뒤 다시 기회를 잡는 게 좋아요. 
“그래요, 지금은 즐기자구요. 근데 나중에 한 번 얘기해봐요”처럼 부드럽게 다음 기회를 열어주는 태도가 필요합니다.`,
]
